import React from 'react';

import AssignmentIcon from '@material-ui/icons/Assignment';
import CancelIcon from '@material-ui/icons/Cancel';

const DADOS_INICIAIS = {
  totalGeral: { count: 0, total: 0 },
  nfe: {
    count: 0,
    total: 0,
    percentual: 0,
    percentualValor: 0,
    porMeioPagamento: [],
    canceladas: { count: 0, total: 0 },
  },
  nfce: {
    count: 0,
    total: 0,
    percentual: 0,
    percentualValor: 0,
    porMeioPagamento: [],
    canceladas: { count: 0, total: 0 },
  },
  canceladas: { count: 0, total: 0 },
};

const NFE_COR = '#3f51b5';
const NFCE_COR = '#00897b';
const CANCELADAS_COR = '#e53935';

const CARTOES_RESUMO = [
  {
    chave: 'totalGeral',
    rotulo: 'Total Transformadas',
    cor: '#1976d2',
    icone: <AssignmentIcon />,
  },
  {
    chave: 'canceladas',
    rotulo: 'Canceladas',
    cor: CANCELADAS_COR,
    icone: <CancelIcon />,
  },
];

const PALETA_MEIOS_PAGAMENTO = [
  '#5c6bc0',
  '#26a69a',
  '#ffa726',
  '#ec407a',
  '#8d6e63',
  '#42a5f5',
  '#66bb6a',
  '#ab47bc',
];

export {
  DADOS_INICIAIS,
  CARTOES_RESUMO,
  PALETA_MEIOS_PAGAMENTO,
  NFE_COR,
  NFCE_COR,
  CANCELADAS_COR,
};
